import { CloudProjectMetadata } from "@domain/project/cloud-project-metadata";
import type { ScopedProject } from "@domain/project/project-guards";
import { BusinessScope } from "@lib/constants/business-scope";

export interface ProjectAggregate {
  project: ScopedProject;
  metadata?: CloudProjectMetadata;
}

export enum ProjectAggregateIssueKind {
  CLOUD_PROJECT_MISSING_METADATA = "CLOUD_PROJECT_MISSING_METADATA",
  INVALID_METADATA_SCOPE = "INVALID_METADATA_SCOPE",
  METADATA_WITHOUT_PROJECT = "METADATA_WITHOUT_PROJECT",
  METADATA_ID_MISMATCH = "METADATA_ID_MISMATCH",
  LOCAL_PROJECT_MISSING_USER_SCOPE = "LOCAL_PROJECT_MISSING_USER_SCOPE",
  DESERIALIZATION_FAILED = "DESERIALIZATION_FAILED",
}

export interface ProjectAggregateIssue {
  kind: ProjectAggregateIssueKind;
  projectId?: string;
  cloudId?: string;
  metadataId?: string;
  message: string;
}

export interface ProjectAggregateLoadResult {
  aggregates: ProjectAggregate[];
  issues: ProjectAggregateIssue[];
  repairableCloudIds: string[];
  reverseOrphanMetadataIds: string[];
}

export interface ProjectAggregateRepairResult {
  attemptedCloudIds: string[];
  repairedCloudIds: string[];
}

export function getProjectId(rawProject: Record<string, unknown>): string | undefined {
  const id = rawProject["id"];
  return typeof id === "string" && id.length > 0 ? id : undefined;
}

export function getCloudId(rawProject: Record<string, unknown>): string | undefined {
  const cloudId = rawProject["cloudId"];
  return typeof cloudId === "string" && cloudId.length > 0 ? cloudId : undefined;
}

export function isCloudLinkedProject(rawProject: Record<string, unknown>): boolean {
  return !!getCloudId(rawProject);
}

export function isValidMetadataScope(scope: unknown): scope is BusinessScope {
  return scope === BusinessScope.FGDS || scope === BusinessScope.MONITORING;
}
